/**
 * Copying text to the clipboard, the way every share surface needs it.
 *
 * `navigator.clipboard` is the real path, but it is absent over plain http,
 * inside some in-app browsers, and in jsdom — so the legacy hidden-textarea
 * + execCommand route stays as the fallback. Resolves true when the text
 * made it out, false when neither path worked; callers own the messaging.
 */
export async function copyTextToClipboard(text) {
	if (!text) return false;
	try {
		if (typeof navigator !== 'undefined' && navigator?.clipboard?.writeText) {
			await navigator.clipboard.writeText(text);
			return true;
		}
		if (typeof document === 'undefined') return false;
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		// execCommand answers false when the browser refused the copy: say
		// so, so no caller claims a copy that did not happen (KPR-1348).
		const copied = document.execCommand('copy');
		document.body.removeChild(textarea);
		return copied !== false;
	} catch {
		return false;
	}
}

export default copyTextToClipboard;
